import { appConfig } from 'shared/appConfig'

export class Logger {
  static log = (...params: any): void => {
    if (appConfig.environment === 'development') {
      console.warn(...params)
    }
  }
}
